// ConfettiCustom - Constants and Default Values
import { ConfettiCustomProps, PhysicsConfig, RendererConfig } from './types';

export const DEFAULT_COLORS = [
  '#0055A4', // Azul Shipeezi
  '#00A4FF', // Azul claro
  '#FFD700', // Dourado
  '#FF6B6B', // Vermelho
  '#4ECDC4', // Turquesa
  '#45B7D1'  // Azul médio
];

export const DEFAULT_PROPS: Required<ConfettiCustomProps> = {
  width: 800,
  height: 600,
  numberOfPieces: 200,
  colors: DEFAULT_COLORS,
  recycle: false,
  duration: 5000,
  gravity: 0.5,
  wind: 0,
  friction: 0.99
};

export const PHYSICS_CONFIG: PhysicsConfig = {
  gravity: DEFAULT_PROPS.gravity,
  wind: DEFAULT_PROPS.wind,
  friction: DEFAULT_PROPS.friction
};

export const SHAPES: Array<'square' | 'circle' | 'rectangle' | 'triangle'> = [
  'square',
  'circle', 
  'rectangle',
  'triangle'
];

export const SIZE_RANGE = {
  min: 4,
  max: 12
};

export const VELOCITY_RANGE = {
  x: { min: -8, max: 8 },
  y: { min: -15, max: -5 }
};

export const ROTATION_SPEED_RANGE = {
  min: -10,
  max: 10
};
